export let getClientEmailAddresses = async (profileId, setClientEmailAddresses, API_URL, authTokens) => {
    if (profileId === 'new') return
  
    let response = await fetch(`${API_URL}/client/profile/email/${profileId}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + authTokens?.access
      }
    })
    let data = await response.json()
    
    setClientEmailAddresses(data)
  }